export default __webpack_public_path__ + "static/media/sea.436cbdce.png";